export const BOARD_BACKGROUND_PRESETS = [
  { name: 'Default white', value: '' },
  { name: 'Midnight', value: 'linear-gradient(135deg, #1e355c 0%, #213f70 100%)' },
  { name: 'Ocean', value: 'linear-gradient(135deg, #1475df 0%, #30a8c3 100%)' },
  { name: 'Blue', value: 'linear-gradient(135deg, #1269d8 0%, #164c9d 100%)' },
  { name: 'Purple', value: 'linear-gradient(135deg, #253b80 0%, #b64b91 100%)' },
  { name: 'Lavender', value: 'linear-gradient(135deg, #8155c6 0%, #cc75c5 100%)' },
  { name: 'Sunset', value: 'linear-gradient(135deg, #ee5e45 0%, #f4a33d 100%)' },
  { name: 'Rose', value: 'linear-gradient(135deg, #e96c9d 0%, #f17974 100%)' },
  { name: 'Mint', value: 'linear-gradient(135deg, #249677 0%, #55bdb6 100%)' },
  { name: 'Slate', value: 'linear-gradient(135deg, #435a7c 0%, #263d60 100%)' },
  { name: 'Ember', value: 'linear-gradient(135deg, #5a3016 0%, #932b16 100%)' },
] as const

export const BOARD_SOLID_BACKGROUNDS = [
  '#ffffff', '#0e82c7', '#d7942e', '#55a139', '#b64839',
  '#8863a1', '#ca4e87', '#4cc16e', '#0da7c1', '#8d9aa0',
] as const
